import React, { useState } from 'react'
import { useLeadEmpStatus } from '../../Hooks/Features/LeadDashboard/useLeadEmpStatus'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Calendar } from 'primereact/calendar';
import { Prev } from 'react-bootstrap/esm/PageItem';
import { SkeletonContainer } from '../Loader/Loader';

const LeadEmpStatus = () => {

    const { cards, data, handleDateChange, filterValues, setFilterValues, loader } = useLeadEmpStatus();

    return (
        <div className='employee-dash-height'>
            <div className="attendance-top-left gap-2 c-pointer w20" style={{ color: "var(--text-color)" }}>
                <FontAwesomeIcon icon="fa-solid fa-backward-step" onClick={() => handleDateChange(-1)} />
                <Calendar
                    value={filterValues?.date}
                    onChange={(e) => setFilterValues((prev) => ({ ...prev, date: e.target.value || new Date() }))}
                    dateFormat="dd-mm-yy"
                />
                <FontAwesomeIcon icon="fa-solid fa-forward-step" onClick={() => handleDateChange(1)} />
            </div>
            {loader ?
                <div className='d-flex gap-2 w100 justify-content-center mt-3' style={{ height: "82%" }}>
                    {Array.from({ length: 6 }, (_, index) => (
                        <div className='card-container w15' key={index}><SkeletonContainer /></div>
                    ))}
                </div>
                :
                <div className='d-flex gap-2 w100 justify-content-center mt-3' style={{ height: "82%" }}>
                    {cards?.map((card) => (
                        <div key={card?.key} className='d-flex gap-2 card-container w15 align-items-center justify-content-center'>
                            <div className='d-flex align-items-center justify-content-center' style={{ width: "35px", height: "35px", borderRadius: "50%", backgroundColor: "rgba(0, 101, 255, 0.15)" }}><FontAwesomeIcon icon={`fa-solid fa-${card?.icon}`} className='text-primary' /></div>
                            <div className='w70'>
                                <div style={{ fontSize: "0.75rem" }}>{card?.label}</div>
                                <div className='fw-bold fs-6'>{data?.[card?.key]}</div>
                                {(card?.key === "total_employee" && data?.new_employee) ? <div className='text-success fw-bold'>+{data?.new_employee} new</div> : ""}
                            </div>
                        </div>
                    ))}
                    <div className='d-flex flex-column gap-2 card-container w15 align-items-center justify-content-center'>
                        <div className='d-flex gap-2 align-items-center justify-content-between w100'>
                            <div className='d-flex align-items-center justify-content-between gap-2 ps-2'>
                                <div className='d-flex align-items-center justify-content-center' style={{ width: "25px", height: "25px", borderRadius: "50%", backgroundColor: "rgba(0, 101, 255, 0.15)" }}>
                                    <FontAwesomeIcon icon="fa-solid fa-child-reaching" className='text-primary' />
                                </div>
                                <div style={{ fontSize: "0.75rem" }}>Maternity: </div>
                            </div>
                            <div className='fw-bold fs-6 pe-2'>{data?.on_maternity_leave}</div>
                        </div>
                        <div className='d-flex gap-2 align-items-center justify-content-between w100'>
                            <div className='d-flex align-items-center justify-content-between gap-2 ps-2'>
                                <div className='d-flex align-items-center justify-content-center' style={{ width: "25px", height: "25px", borderRadius: "50%", backgroundColor: "rgba(0, 101, 255, 0.15)" }}>
                                    <FontAwesomeIcon icon="fa-solid fa-arrow-right-from-bracket" className='text-primary' />
                                </div>
                                <div style={{ fontSize: "0.75rem" }}>Resigned: </div>
                            </div>
                            <div className='fw-bold fs-6 pe-2'>{data?.resignd_users}</div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default LeadEmpStatus